export function closeNewTab(targetTab, linkTarget) {
    if (!targetTab) {
        return;
    }
    if (linkTarget === '_blank') {
        targetTab.close();
    }
}
//# sourceMappingURL=closeNewTab.js.map